import { registerLocaleData } from '@angular/common'
import { APP_INITIALIZER, Injectable, LOCALE_ID, inject } from '@angular/core'
import { loadTranslations } from '@angular/localize'
import { LocaleService } from 'projects/commons/src/lib/services/locale.service'

type LocalTranslationsJson = {
  locale: string
  translations: Record<string, string>
}

@Injectable({
  providedIn: 'root',
})
class I18n {
  locale = ''

  // Remember already loaded filse so the app doesn't have to load them again
  private loadedFiles = new Set<string>()

  private localeSvc = inject(LocaleService)

  async setLocale() {
    this.locale = this.localeSvc.selectedLocale()

    const language = this.locale.split('-')[0]

    try {
      // Use web pack magic string to only include required locale data
      const localeModule = await import(
        /* @vite-ignore */
        `/assets/i18n/locales/${language}.js`
      )

      // Set locale for built in pipes, etc.
      registerLocaleData(localeModule.default)
    } catch (error) {
      // no locale data found for this language
      console.warn(`No locale data found for language: ${language}`)
    }

    const localeTranslations = await fetch(
      `/assets/i18n/translations/${this.locale}.json`,
    )
      .then((response: Response) => response.json())
      .then((jsonData: LocalTranslationsJson) => {
        return jsonData.translations
      })
    // .catch(error => this.defaultErrorHandler(error, jsonDataUrl));

    // Load translations for the current locale at run-time
    loadTranslations(localeTranslations)
  }
}

// function setLocale() {
//   return provideAppInitializer(() => {
//     const i18n = inject(I18n)
//     i18n.setLocale()
//   })
// }

// Load locale data at app start-up
function setLocale() {
  return {
    provide: APP_INITIALIZER,
    useFactory: (i18n: I18n) => () => i18n.setLocale(),
    deps: [I18n],
    multi: true,
  }
}

// Set the runtime locale for the app
function setLocaleId() {
  return {
    provide: LOCALE_ID,
    useFactory: (i18n: I18n) => i18n.locale,
    deps: [I18n],
  }
}

export const I18nModule = {
  setLocale: setLocale,
  setLocaleId: setLocaleId,
}
